import * as React from 'react';

function BelbimBlueIcon({
  role = 'img',
  'aria-label': ariaLabel = 'Belbim',
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="83px"
      height="19px"
      viewBox="0 0 83 19"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      role={role}
      aria-label={ariaLabel}
      {...props}
    >
      {/*<title>3CA41413-F597-4659-92ED-8A0949172763</title>*/}
      <defs>
        <filter id="filter-1">
          <feColorMatrix
            in="SourceGraphic"
            type="matrix"
            values="0 0 0 0 0.333333 0 0 0 0 0.827451 0 0 0 0 1.000000 0 0 0 1.000000 0"
          ></feColorMatrix>
        </filter>
      </defs>
      <g id="Welcome" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-3" transform="translate(-664.000000, -912.000000)" filter="url(#filter-1)">
          <g transform="translate(537.000000, 893.000000)">
            <g id="belbim" transform="translate(127.000000, 19.000000)" fill="#FFFFFF">
              <path
                d="M0,16.3370385 L0,2.11913848 L5.23673,2.11913848 C9.00883,2.11913848 10.9018,3.33505848 10.9018,5.76688848 C10.9018,7.05188848 10.2662,7.97763848 9.00883,8.54414848 C10.9847,9.16591848 11.9657,10.3956385 11.9657,12.2471385 C11.9657,14.9691385 10.0866,16.3232385 6.34211,16.3232385 L0,16.3232385 L0,16.3370385 Z M5.41635,7.74274848 C6.68754,7.74274848 7.32313,7.24532848 7.32313,6.26430848 C7.32313,5.18655848 6.68754,4.63387848 5.41635,4.63387848 L3.57866,4.63387848 L3.57866,7.74274848 L5.41635,7.74274848 Z M3.57866,13.7394385 L5.63743,13.7394385 C6.42501,13.7394385 7.00533,13.6565385 7.3784,13.4769385 C7.93109,13.2281385 8.20743,12.7584385 8.20743,12.0813385 C8.20743,10.8930385 7.35076,10.2989385 5.62361,10.2989385 L3.57866,10.2989385 L3.57866,13.7394385 Z"
                id="Shape"
              ></path>
              <polygon
                id="Path"
                points="34.2803 16.3370385 34.2803 2.11913848 37.8451 2.11913848 37.8451 13.5874385 43.9661 13.5874385 43.9661 16.3370385"
              ></polygon>
              <path
                d="M45.5693,16.3370385 L45.5693,2.11913848 L50.8061,2.11913848 C54.5782,2.11913848 56.4711,3.33505848 56.4711,5.76688848 C56.4711,7.05188848 55.8355,7.97763848 54.5782,8.54414848 C56.554,9.16591848 57.5351,10.3956385 57.5351,12.2471385 C57.5351,14.9691385 55.6697,16.3232385 51.9114,16.3232385 L45.5693,16.3232385 L45.5693,16.3370385 Z M50.9857,7.74274848 C52.2569,7.74274848 52.8925,7.25914848 52.8925,6.26430848 C52.8925,5.18655848 52.2569,4.63387848 50.9857,4.63387848 L49.148,4.63387848 L49.148,7.74274848 L50.9857,7.74274848 Z M49.1342,13.7394385 L51.1929,13.7394385 C51.9805,13.7394385 52.5609,13.6565385 52.9339,13.4769385 C53.4866,13.2281385 53.763,12.7584385 53.763,12.0813385 C53.763,10.8930385 52.9063,10.2989385 51.1791,10.2989385 L49.1342,10.2989385 L49.1342,13.7394385 Z"
                id="Shape"
              ></path>
              <path
                d="M62.9512,16.3369385 L62.9512,2.38151848 L66.7233,2.38151848 L66.7233,3.88759848 C67.8563,2.71313848 69.2104,2.13280848 70.7717,2.13280848 C72.5265,2.13280848 73.7148,2.86512848 74.3366,4.34356848 C75.7321,2.86512848 77.252,2.13280848 78.9101,2.13280848 C81.6321,2.13280848 83,3.68033848 83,6.78921848 L83,16.3231385 L79.2002,16.3231385 L79.2002,7.31426848 C79.2002,5.67001848 78.6337,4.84098848 77.5007,4.84098848 C76.4644,4.84098848 75.5525,5.47657848 74.7925,6.74776848 L74.7925,16.3369385 L71.1172,16.3369385 L71.1172,7.31426848 C71.1172,5.67001848 70.5506,4.84098848 69.4176,4.84098848 C68.3675,4.84098848 67.4694,5.47657848 66.7233,6.74776848 L66.7233,16.3369385 L62.9512,16.3369385 Z"
                id="Path"
              ></path>
              <path
                d="M58.0879,16.3369385 L58.0879,6.70634848 C58.1293,6.76161848 58.1708,6.80306848 58.2261,6.84451848 C58.682,7.28666848 59.2347,7.50774848 59.8841,7.50774848 C60.5474,7.50774848 61.1,7.28666848 61.5422,6.85833848 C61.5975,6.80306848 61.6527,6.74779848 61.6942,6.67870848 L61.7495,6.67870848 L61.7495,16.3369385 L58.0879,16.3369385 Z"
                id="Path"
              ></path>
              <path
                d="M57.5898,4.16357848 C57.5898,3.51416848 57.8109,2.96147848 58.2531,2.51932848 C58.709,2.06335848 59.2617,1.84228848 59.9111,1.84228848 C60.5744,1.84228848 61.1271,2.06335848 61.5692,2.50550848 C62.0114,2.94765848 62.2324,3.50034848 62.2324,4.16357848 C62.2324,4.82680848 62.0114,5.37948848 61.5692,5.82164848 C61.1271,6.26379848 60.5744,6.47105848 59.9111,6.47105848 C59.2617,6.47105848 58.709,6.24997848 58.2531,5.80782848 C57.8109,5.36567848 57.5898,4.81298848 57.5898,4.16357848 Z"
                id="Path"
              ></path>
              <path
                d="M13.4163,8.83413848 C14.5493,6.47139848 16.7186,4.41262848 19.3024,3.01708848 C18.0865,4.37117848 16.9258,5.90488848 16.4146,7.48004848 C14.7842,12.5371385 18.349,16.3092385 24.0693,15.9500385 C27.3578,15.7427385 30.8398,14.2919385 33.4098,12.0673385 C30.6463,16.1020385 24.774,18.7687385 19.634,18.3403385 C13.9275,17.8567385 11.1364,13.6010385 13.4163,8.83413848 Z"
                id="Path"
              ></path>
              <path
                d="M18.2107,7.02402848 C19.1227,5.11724848 20.8775,3.45917848 22.9639,2.32616848 C21.9828,3.41772848 21.2229,4.63364848 20.8222,5.91864848 C19.5096,9.99473848 22.1901,13.0621385 26.805,12.7720385 C29.458,12.6061385 32.1799,11.3488385 34.2525,9.55257848 C32.028,12.7996385 27.3716,15.0380385 23.2264,14.6925385 C18.6114,14.3057385 16.373,10.8790385 18.2107,7.02402848 Z"
                id="Path"
              ></path>
              <path
                d="M27.7446,6.77527848 C26.2523,8.15699848 24.7324,8.72350848 23.7238,8.84785848 C24.3593,8.46097848 25.6305,7.72866848 26.501,6.62328848 C28.1314,4.55070848 28.3111,2.18795848 26.7635,1.15166848 C25.8654,0.55752748 24.6357,0.58516248 23.4336,1.11021848 C25.1193,-0.23005352 27.6755,-0.40967782 28.8776,0.86150848 C30.2178,2.29849848 29.4855,4.99285848 27.7446,6.77527848 Z"
                id="Path"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default BelbimBlueIcon;
